import { useEffect } from "react";
import { useSnapshot } from "valtio";
import { configStore, loginStore } from "../state/CommonState";
import { enquiryStore } from "../enquiry/enquiry-data";
import HomeMain from "./home-main";
import { rtpStore } from "../pricing/pricing-store";


export default function Spotv3(params) {
  useSnapshot(enquiryStore);
  useSnapshot(configStore);
  useSnapshot(loginStore);
  useSnapshot(rtpStore);

  useEffect(() => {
    enquiryStore.initialize();
    enquiryStore.currentCargoTableKey = "" + new Date().getMilliseconds();
    enquiryStore.current.createdBy = loginStore.email;
    // enquiryStore.current.gst = configStore.currentSelectedEntity.gst;
    enquiryStore.current.shipmentType =
      configStore.homescreenCurrentShipmentType;
    configStore.homescreenCurrentView = "new";
    configStore.scheduleOrCarrierform = "schedule";
    if(loginStore.isClient() && configStore.currentSelectedEntity.entityId.length === 0){
      rtpStore.customerTBA = "TBA"
    }
  
    return ()=>{
      enquiryStore.initialize();
    }
  }, []);
  return <HomeMain />;
}
